import { BEARER_TOKEN } from 'src/dataLayer/env';
import { getTrackingUUID } from 'src/dataLayer/localData/cookies';

export default () => {
  const headers = {
    'Content-Type': 'application/json',
    'X-Babbel-Tracking-UUID': getTrackingUUID()
  };

  if (BEARER_TOKEN && BEARER_TOKEN !== 'undefined') {
    headers.Authorization = `Bearer ${BEARER_TOKEN}`;
  }

  return headers;
};
